// Shared room-exit flow for Room page and exit modal

import { useCallback } from 'react';
import { useRoomClose } from './useRoomClose';
import { useRoomConfig } from './useRoomConfig';
import { useRoomPlayers } from './useRoomPlayers';
import { analyticsService } from '../services/analyticsService';

interface UseRoomGameExitArgs {
  linkLocation: 'room_page' | 'exit_game_modal';
}

interface UseRoomGameExitResult {
  exitToLibrary: () => Promise<void>;
  isClosing: boolean;
}

export function useRoomGameExit({
  linkLocation,
}: UseRoomGameExitArgs): UseRoomGameExitResult {
  const { closeRoom, isClosing } = useRoomClose();
  const { roomCode, gameName } = useRoomConfig();
  const { playerCount } = useRoomPlayers();

  const exitToLibrary = useCallback(async () => {
    analyticsService.trackButtonClick('Go To Game Library', {
      link_location: linkLocation,
      room_code: roomCode || 'unknown',
      game_name: gameName || 'Unknown Game',
      player_count: playerCount,
    });

    analyticsService.trackRoomClosed({
      room_code: roomCode || 'unknown',
      game_name: gameName || 'Unknown Game',
    });

    await closeRoom();
  }, [closeRoom, gameName, linkLocation, playerCount, roomCode]);

  return { exitToLibrary, isClosing };
}
